import { JobItem, WorkType } from '@kanda-libs/ks-frontend-services';
import { BASE_ITEM } from 'pages/Enquiry/WorkDetails/Fields/constants';
import { JobInfoValues } from './useEnquiryQuoteConfirmDetailsForm';

export const formatJobItems = (items: JobItem[]): JobItem[] =>
  items.map((item) => {
    const { vat_rate: vatRate, vat, price } = item;
    if (vatRate !== '5%' && vatRate !== '20%') return item;
    const vatAmount = vat.amount;
    if (vatAmount !== 0) return item;
    const priceAmount = price.amount;
    if (priceAmount === 0) return item;
    const parsedVatPct = parseInt(vatRate.replace('%', ''), 10);
    const calculatedPriceAmount = Math.floor(
      priceAmount * (100 / (100 + parsedVatPct)),
    );
    const calculatedVatAmount = calculatedPriceAmount * (parsedVatPct / 100);
    return {
      ...item,
      vat: {
        ...item.vat,
        amount: calculatedVatAmount,
      },
      price: {
        ...item.price,
        amount: calculatedPriceAmount,
      },
    };
  });

export const getDefaultValues = (
  workTypes: WorkType[],
  extractedWorkType?: WorkType,
  extractedJobItems?: JobItem[],
): Partial<JobInfoValues> => {
  const workType =
    extractedWorkType && workTypes.includes(extractedWorkType)
      ? extractedWorkType
      : undefined;
  const jobItems = extractedJobItems || [BASE_ITEM];
  return {
    work_type: workType,
    job_items: formatJobItems(jobItems),
  };
};
